import { render, staticRenderFns } from "./loadingpage.vue?vue&type=template&id=84763a72"
import script from "./loadingpage.vue?vue&type=script&lang=js"
export * from "./loadingpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports